import React from "react";
import {
  Filter,
  TextInput,
  List,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  DateField,
  Toolbar,
  SaveButton,
  FunctionField,
  Link,
  Button,
  NumberInput,
  Edit,
  LongTextInput,
  SimpleForm
} from "react-admin";
import moment from "moment";
import Payment from "@material-ui/icons/Payment";
import styled from "styled-components";
import { getPermissionRole } from "../util";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

const FilterExtraKm = props => (
  <Filter {...props}>
    <TextInput />
    <TextInput label="Client First Name" source="client_first_name" alwaysOn />
    <TextInput label="Client Last Name" source="client_last_name" alwaysOn />
  </Filter>
);

const ProcessToolbar = (props, classes, className) => (
  <Toolbar {...props}>
    <SaveButton label="Process Charge" />
  </Toolbar>
);

const ChargeButton = props => (
  <Button
    component={Link}
    to={{
      pathname: `/extra_km_rentals/${props.record.id}`
    }}
    label="Charge Km"
  >
    <Payment />
  </Button>
);

const rentalDays = rental => {
  let days = moment(rental.date_2).diff(rental.date_1, 'days')
  if (rental.time_1 === '10:00:00' && rental.time_2 === '18:00:00') {
    days += 1
  } else if (rental.time_1 === '18:00:00' && rental.time_2 === '10:00:00') {
    days -= 1
  }
  return days
}

/** KM incluidos: snapshot weekend (700) o días × 300. */
const includedKm = rental => {
  if (rental.included_km != null && rental.included_km !== '') {
    return Number(rental.included_km)
  }
  return rentalDays(rental) * 300
}

const extraKmAmount = rental => {
  return (rental.km_2 - rental.km_1) - includedKm(rental)
}

export const ExtraKmRentalsEdit = props => {
  return (
    <Edit title={<ExtraKmRentalsEditTitle />} {...props}>
      <SimpleForm toolbar={<ProcessToolbar props={{ ...props }} />}>
        <TextField label="Customer ID" source="id" />
        <ReferenceField
          label="First Name"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <TextField source="r_first_name" />
        </ReferenceField>
        <ReferenceField
          label="Last Name"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <TextField source="r_last_name" />
        </ReferenceField>

        <FunctionField
          label="Stripe Information"
          style={{ color: "red", width: "100%" }}
          render={rental => {
            const stripInfoText =
              rental.client.stripe === null
                ? "Client has no stripe (credit card information). Please don't forget to include information."
                : `Stripe account - ${rental.client.stripe}`;
            return stripInfoText;
          }}
        />

        <DateField label="Pick-up date" source="date_1" />
        <DateField label="Drop-off date" source="date_2" />
        <ReferenceField
          label="Pick-up city"
          source="location_id_1"
          reference="locations"
          linkType={false}
        >
          <TextField source="location_name" />
        </ReferenceField>
        <ReferenceField
          label="Drop-off city"
          source="location_id_2"
          reference="locations"
          linkType={false}
        >
          <TextField source="location_name" />
        </ReferenceField>
        <FunctionField label="Rental Days" render={rentalDays} />
        <FunctionField
          label="Extra KM"
          render={rental => {
            return extraKmAmount(rental);
          }}
        />

        <FunctionField
          addLabel={false}
          render={rental => {
            const extraKM = extraKmAmount(rental);
            return (
              <NumberInput
                source="extra_km_value"
                defaultValue={() => (extraKM * 0.35).toFixed(2)}
              />
            );
          }}
        />

        <LongTextInput source="comments" label="Comments" />
      </SimpleForm>
    </Edit>
  );
};

const ExtraKmRentalsEditTitle = object => (
  <span>
    {" Edit km for Rental"} &quot;{object.record.id}&quot;
  </span>
);

export const ExtraKmRentalsList = props => {
  return (
    <List
      {...props}
      pagination={<ListPagination />}
      filters={<FilterExtraKm />}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField label="Customer ID" source="id" />
        <ReferenceField
          label="First Name"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <TextField source="r_first_name" />
        </ReferenceField>
        <ReferenceField
          label="Last Name"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <TextField source="r_last_name" />
        </ReferenceField>
        <DateField label="Pick-up date" source="date_1" />
        <DateField label="Drop-off date" source="date_2" />
        <ReferenceField
          label="Pick-up city"
          source="location_id_1"
          reference="locations"
          linkType={false}
        >
          <FunctionField
            label="Pick-up city"
            addLabel={false}
            render={(r) => {
              return <StyledDiv color={r.color}>{r.location_name}</StyledDiv>;
            }}
          />
          {/* <TextField source="location_name" /> */}
        </ReferenceField>
        <ReferenceField
          label="Drop-off city"
          source="location_id_2"
          reference="locations"
          linkType={false}
        >
          <FunctionField
            label="Drop-off city"
            addLabel={false}
            render={(r) => {
              return <StyledDiv color={r.color}>{r.location_name}</StyledDiv>;
            }}
          />
          {/*  <TextField source="location_name" /> */}
        </ReferenceField>
        <FunctionField label="Rental Days" render={rentalDays} />
        <FunctionField
          label="Extra KM"
          render={rental => {
            return extraKmAmount(rental);
          }}
        />
        <FunctionField
          label="KM Charge"
          render={rental => {
            const extraKM = extraKmAmount(rental);
            return Number(extraKM * 0.35).toFixed(2);
          }}
        />
        {([1, 2, 3, 4, 6, 9].includes(getPermissionRole()) &&
          <ChargeButton />
        )}
       
      </Datagrid>
    </List>      
  )

}




// WEBPACK FOOTER //
// ./src/resources/extraKmRentals.js